import { handleShareClick } from '/js/shareLink.js';
import data from '/data/forfettario.json';
// L'elenco ATECO (1,7 MB) si carica solo quando l'utente apre la ricerca:
// vedi loadAtecoData().
import { calcolaForfettario } from '/js/forfettarioCalc.js';
import { confrontaRegimi, costiImpliciti } from '/js/confrontoRegimi.js';
import { renderConfronto, linkAllOrdinario } from '/js/confrontoRegimiUI.js';
import fiscalData from '/data/data.json';
const isResultsPage = window.location.pathname === '/piva-forfettario/risultati';
const SHARE_CAMPAIGN = 'sharing_link';
const encodeParams = (obj) => {
    try {
        return btoa(encodeURIComponent(JSON.stringify(obj)));
    } catch (e) {
        console.error('encodeParams failed', e);
        return null;
    }
};

const decodeParams = (encoded) => {
    try {
        return JSON.parse(decodeURIComponent(atob(encoded)));
    } catch (e) {
        console.error('decodeParams failed', e);
        return null;
    }
};

const formatEuro = (value) =>
    new Intl.NumberFormat('it-IT', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping: 'always'
    }).format(value);

const handleShare = (shareButton) =>
    handleShareClick(shareButton, { campaign: SHARE_CAMPAIGN });

document.addEventListener('DOMContentLoaded', async () => {


    const backButton = document.getElementById('backButton');
    const inputSection = document.querySelector('.input-section');
    const resultSection = document.querySelector('.result-section');
    const backButtonTop = document.getElementById('pivaBackButtonTop');
    const shareButton = document.getElementById('shareButton');
    const faqScrollButton = document.getElementById('faqScrollButton');
    const detailScrollButton = document.getElementById('detailScrollButton');
    const pivaQuickEditModal = document.getElementById('pivaQuickEditModal');
    const pivaQuickEditClose = document.getElementById('pivaQuickEditClose');
    const pivaQuickEditForm = document.getElementById('pivaQuickEditForm');
    const pivaQuickEditFatturatoInput = document.getElementById('piva-quick-fatturato');
    const pivaQuickEditFatturatoFormattedInput = document.getElementById('piva-quick-fatturato-formatted');
    const pivaQuickEditAnniAttivitaSelect = document.getElementById('piva-quick-anni-attivita');
    const pivaQuickEditCassaSelect = document.getElementById('piva-quick-cassa');
    const pivaQuickEditToConfiguratorButton = document.getElementById('pivaQuickEditToConfigurator');
    let pivaQuickEditScrollY = 0;
    let imposte, contributi, nettoAnnuo, nettoMensile, imponibileContributi, imponibileIrpef;

    const aliquotaIrpefElement = document.getElementById('anni-attivita');
    const coefficienteRedditivitàElement = document.getElementById('tipo-attivita');
    const entePrevidenzialeElement = document.getElementById('cassa-previdenziale');
    const fatturatoAnnuoElement = document.getElementById('ral');
    const fatturatoFormattedElement = document.getElementById('ral-formatted');
    const toggleButton = document.getElementById('toggleButton');
    const formaAttivitaElement = document.getElementById('forma-attivita');
    const atecoTrigger = document.getElementById('atecoSearchTrigger');
    const atecoSelectedClear = document.getElementById('atecoSelectedClear');
    const atecoModal = document.getElementById('atecoModal');
    const atecoSearchInput = document.getElementById('atecoSearchInput');
    const atecoSearchResults = document.getElementById('atecoSearchResults');
    const atecoSearchEmpty = document.getElementById('atecoSearchEmpty');
    const inpsArtComFields = document.getElementById('inpsArtComFields');
    const nuovaAttivitaArtcomGroup = document.getElementById('nuovaAttivitaArtcomGroup');
    const riduzione35Group = document.getElementById('riduzione35Group');
    const mesiAttivitaGroup = document.getElementById('mesiAttivitaGroup');
    const riduzione35Element = document.getElementById('riduzione-35');
    const riduzione50Element = document.getElementById('riduzione-50');
    const nuovaAttivitaArtComElement = document.getElementById('nuova-attivita-artcom');
    const mesiAttivitaElement = document.getElementById('mesi-attivita');
    const dipendenteFullTimeElement = document.getElementById('dipendente-fulltime');
    const ralDipendenteElement = document.getElementById('ral-dipendente');
    const ralDipendenteGroup = document.getElementById('ralDipendenteGroup');
    const ralDipendenteError = document.getElementById('ralDipendenteError');
    const dipendenteRiduzioniGroup = document.getElementById('dipendenteRiduzioniGroup');
    const riduzioneContributiDipendenteElement = document.getElementById('riduzione-contributi-dipendente');

    // Define required fields in order
    const requiredFields = [
        'ral',
        'anni-attivita',
        'tipo-attivita',
        'forma-attivita',
        'cassa-previdenziale',
        'mesi-attivita',
        'ral-dipendente'
    ];

    const isArtComSelected = () =>
        ['INPS_ART', 'INPS_COM'].includes(entePrevidenzialeElement?.value);

    function validateField(field) {
        if (!field) return false;
        if (field.id === 'ral') {
            // For the fatturato field, check if there's a valid numeric value
            return parseFloat(field.value) > 0;
        }
        if (field.id === 'mesi-attivita') {
            if (!isArtComSelected()) return true;
            const mesiValue = parseInt(field.value, 10);
            return Number.isInteger(mesiValue) && mesiValue >= 1 && mesiValue <= 12;
        }
        if (field.id === 'ral-dipendente') {
            if (!dipendenteFullTimeElement?.checked) return true;
            const ralValue = parseFloat(field.value);
            return Number.isFinite(ralValue) && ralValue >= 0;
        }
        return field.value.trim() !== '';
    }

    function updateFieldHighlighting() {
        // Remove invalid-field class from all fields first
        requiredFields.forEach(fieldId => {
            const field = document.getElementById(fieldId);
            if (field) {
                field.classList.remove('invalid-field');
            }
        });
        if (atecoTrigger) {
            atecoTrigger.classList.remove('invalid-field');
        }

        // Find the first empty required field and highlight it
        const firstEmptyField = requiredFields.find(fieldId => {
            const field = document.getElementById(fieldId);
            return field && !validateField(field);
        });

        if (firstEmptyField) {
            const field = document.getElementById(firstEmptyField);
            if (field) {
                field.classList.add('invalid-field');
            }
            if (firstEmptyField === 'tipo-attivita' && atecoTrigger) {
                atecoTrigger.classList.add('invalid-field');
            }
        }
    }

    function updateInpsArtComFields() {
        const isArtCom = isArtComSelected();
        if (inpsArtComFields) {
            inpsArtComFields.classList.toggle('hidden-block', !isArtCom);
        }
        if (mesiAttivitaElement) {
            mesiAttivitaElement.required = isArtCom;
            if (isArtCom && !mesiAttivitaElement.value) {
                mesiAttivitaElement.value = '12';
            }
        }
    }

    function updateRiduzione35Availability() {
        if (!riduzione35Element) return;
        const disableRiduzione35 = Boolean(riduzioneContributiDipendenteElement?.checked);
        riduzione35Element.disabled = disableRiduzione35;
        if (disableRiduzione35) {
            riduzione35Element.checked = false;
        }
        if (mesiAttivitaElement) {
            mesiAttivitaElement.disabled = disableRiduzione35;
        }
        if (mesiAttivitaGroup) {
            mesiAttivitaGroup.classList.toggle('hidden-block', disableRiduzione35);
        }
        if (riduzione35Group) {
            riduzione35Group.classList.toggle('hidden-block', disableRiduzione35);
        }
        if (nuovaAttivitaArtcomGroup) {
            nuovaAttivitaArtcomGroup.classList.toggle('hidden-block', disableRiduzione35);
        }
    }

    function updateRiduzioneFieldsVisibility() {
        const isNuovaAttivita = nuovaAttivitaArtComElement?.checked;
        const hasRiduzioneDipendente = Boolean(riduzioneContributiDipendenteElement?.checked);
        const riduzione50Group = document.getElementById('riduzione50Group');
        
        // Mostra 50% se nuova attività, altrimenti mostra 35%
        if (riduzione50Group) {
            riduzione50Group.classList.toggle('hidden-block', !isNuovaAttivita || hasRiduzioneDipendente);
        }
        if (riduzione35Group) {
            riduzione35Group.classList.toggle('hidden-block', isNuovaAttivita || hasRiduzioneDipendente);
        }
        
        // Disabilita e deseleziona quando non visibile
        if (riduzione50Element) {
            if (!isNuovaAttivita || hasRiduzioneDipendente) {
                riduzione50Element.checked = false;
            }
        }
        if (riduzione35Element) {
            if (isNuovaAttivita || hasRiduzioneDipendente) {
                riduzione35Element.checked = false;
            }
        }
    }


    function updateNuovaAttivitaArtComAvailability() {
        if (!nuovaAttivitaArtComElement) return;
        const isArtCom = isArtComSelected();
        const disableNuovaAttivita = !isArtCom || Boolean(riduzioneContributiDipendenteElement?.checked);
        nuovaAttivitaArtComElement.disabled = disableNuovaAttivita;
        if (disableNuovaAttivita) {
            nuovaAttivitaArtComElement.checked = false;
        }
        // Mostra/nascondi il campo solo se è Artigiani/Commercianti
        const nuovaAttivitaGroup = nuovaAttivitaArtComElement?.closest('.input-group');
        if (nuovaAttivitaGroup) {
            nuovaAttivitaGroup.style.display = isArtCom ? 'block' : 'none';
        }
        // Aggiorna visibilità dei campi riduzione
        updateRiduzioneFieldsVisibility();
    }

    const cassaByForma = {
        libero_senza_cassa: ['INPS_GS'],
        libero_con_cassa: [
            'CASSA_FORENSE',
            'INARCASSA',
            'ENPAM',
            'ENPACL',
            'CNPADC',
            'CNPR',
            'CIPAG',
            'ENPAP',
            'ENPAV',
            'ENPAB',
            'EPAP',
            'EPPI',
            'ENPAPI'
        ],
        ditta_artigiana: ['INPS_ART'],
        ditta_commerciale: ['INPS_COM', 'ENASARCO_MONO', 'ENASARCO_PLURI']
    };

    function updateCassaOptions() {
        if (!entePrevidenzialeElement) return;
        const selectedForma = formaAttivitaElement?.value || '';
        
        // Abilita/disabilita il campo cassa in base alla selezione di forma-attivita
        if (entePrevidenzialeElement) {
            entePrevidenzialeElement.disabled = !selectedForma;
            if (!selectedForma) {
                entePrevidenzialeElement.value = '';
            }
        }
        
        // Se non c'è selezione, esci
        if (!selectedForma) {
            return;
        }
        
        // Se è "altro", mostra tutte le opzioni
        const allowed = selectedForma === 'altro' ? null : (cassaByForma[selectedForma] || null);
        const previousValue = entePrevidenzialeElement.value;
        const options = Array.from(entePrevidenzialeElement.options || []);
        options.forEach((option) => {
            if (!option.value) return;
            const isAllowed = !allowed || allowed.includes(option.value);
            option.hidden = !isAllowed;
            option.disabled = !isAllowed;
        });
        if (allowed && allowed.length === 1) {
            entePrevidenzialeElement.value = allowed[0];
        } else if (allowed && !allowed.includes(entePrevidenzialeElement.value)) {
            entePrevidenzialeElement.value = '';
        }
        if (previousValue !== entePrevidenzialeElement.value) {
            updateInpsArtComFields();
        }
    }

    function updateDipendenteFields() {
        const isDipendente = dipendenteFullTimeElement?.checked;
        if (ralDipendenteGroup) {
            ralDipendenteGroup.classList.toggle('hidden-block', !isDipendente);
        }
        if (ralDipendenteElement) {
            ralDipendenteElement.required = Boolean(isDipendente);
            if (!isDipendente) {
                ralDipendenteElement.value = '';
            }
        }
        if (!isDipendente && riduzioneContributiDipendenteElement) {
            riduzioneContributiDipendenteElement.checked = false;
        }
    }

    function clampMesiAttivita() {
        if (!mesiAttivitaElement) return;
        const parsed = parseInt(mesiAttivitaElement.value, 10);
        if (!Number.isFinite(parsed)) {
            mesiAttivitaElement.value = '';
            return;
        }
        const clamped = Math.min(Math.max(parsed, 1), 12);
        mesiAttivitaElement.value = String(clamped);
    }

    function clampRalDipendente() {
        if (!ralDipendenteElement) return;
        const parsed = parseFloat(ralDipendenteElement.value);
        if (!Number.isFinite(parsed)) {
            ralDipendenteElement.value = '';
            return;
        }
        ralDipendenteElement.value = String(Math.max(parsed, 0));
    }

    function isDipendenteEligible(ralDipendente) {
        if (!dipendenteFullTimeElement?.checked) return true;
        const ralValue = Number.isFinite(ralDipendente) ? ralDipendente : parseFloat(ralDipendenteElement?.value);
        if (!Number.isFinite(ralValue)) return true;
        return (ralValue * 0.909) <= 35000;
    }

    function updateDipendenteEligibilityState() {
        if (!ralDipendenteError) return;
        const ralValue = parseFloat(ralDipendenteElement?.value);
        const hasRal = Number.isFinite(ralValue);
        const showError = Boolean(dipendenteFullTimeElement?.checked) && hasRal && !isDipendenteEligible(ralValue);
        ralDipendenteError.classList.toggle('hidden-block', !showError);
    }

    function updateDipendenteRiduzioniState() {
        if (!dipendenteRiduzioniGroup) return;
        const ralValue = parseFloat(ralDipendenteElement?.value);
        const hasRal = Number.isFinite(ralValue);
        const isEligible = Boolean(dipendenteFullTimeElement?.checked) && hasRal && isDipendenteEligible(ralValue);
        dipendenteRiduzioniGroup.classList.toggle('hidden-block', !isEligible);
        if (!isEligible && riduzioneContributiDipendenteElement) {
            riduzioneContributiDipendenteElement.checked = false;
        }
    }

    function updateToggleButtonState() {
        const baseFields = [
            fatturatoAnnuoElement,
            aliquotaIrpefElement,
            coefficienteRedditivitàElement,
            formaAttivitaElement,
            entePrevidenzialeElement
        ];
        const extraFields = [mesiAttivitaElement];
        const dipendenteFields = [ralDipendenteElement];
        const hasEmptyBase = baseFields.some((field) => !validateField(field));
        const hasEmptyExtra = isArtComSelected() && extraFields.some((field) => !validateField(field));
        const hasEmptyDipendente = dipendenteFullTimeElement?.checked && dipendenteFields.some((field) => !validateField(field));
        const ralValue = parseFloat(ralDipendenteElement?.value);
        const isIneligible = Boolean(dipendenteFullTimeElement?.checked) && Number.isFinite(ralValue) && !isDipendenteEligible(ralValue);
        const isEmpty = hasEmptyBase || hasEmptyExtra || hasEmptyDipendente || isIneligible;

        if (toggleButton) {
          toggleButton.disabled = isEmpty;
        }
        updateRiduzione35Availability();
        updateNuovaAttivitaArtComAvailability();
        updateDipendenteEligibilityState();
        updateDipendenteRiduzioniState();
        updateFieldHighlighting();
    }

    
// Add validation on input/change for all fields (home only)
    if (!isResultsPage) {
      requiredFields.forEach(fieldId => {
        const element = document.getElementById(fieldId);
        if (element) {
          element.addEventListener('input', updateToggleButtonState);
          element.addEventListener('change', updateToggleButtonState);
        }
      });

      // Ensure initial state after attaching listeners
      // Disabilita inizialmente il campo cassa
      if (entePrevidenzialeElement) {
        entePrevidenzialeElement.disabled = true;
      }
      updateCassaOptions();
      updateInpsArtComFields();
      updateDipendenteFields();
      updateNuovaAttivitaArtComAvailability();
      updateToggleButtonState();
    }

    // Format and show formatted input on blur (home only)
    if (!isResultsPage) {
      fatturatoAnnuoElement.addEventListener('blur', () => {
          let fatturatoValue = parseFloat(fatturatoAnnuoElement.value) || 0;
          
          // Apply validation limits
          if (fatturatoValue < 0) {
              fatturatoValue = 0;
              fatturatoAnnuoElement.value = 0;
          } else if (fatturatoValue > 1000000) {
              // Solo un tetto tecnico. Oltre 85.000 il valore NON viene piu'
              // riscritto a 85.000: il confronto tra regimi spiega che il
              // forfettario decade e mostra i numeri dell'ordinario.
              fatturatoValue = 1000000;
              fatturatoAnnuoElement.value = 1000000;
          }
          
          // Format the value and show formatted input
          if (fatturatoValue > 0) {
              fatturatoFormattedElement.value = fatturatoValue.toLocaleString('it-IT') + '€';
              fatturatoAnnuoElement.style.display = 'none';
              fatturatoFormattedElement.style.display = 'block';
          }
      });

      // Show numeric input on focus of formatted input
      fatturatoFormattedElement.addEventListener('focus', () => {
          fatturatoFormattedElement.style.display = 'none';
          fatturatoAnnuoElement.style.display = 'block';
          fatturatoAnnuoElement.focus();
      });
    }

    if (!isResultsPage) {
        if (entePrevidenzialeElement) {
            entePrevidenzialeElement.addEventListener('change', () => {
                updateInpsArtComFields();
                updateNuovaAttivitaArtComAvailability();
                updateToggleButtonState();
            });
        }
        if (formaAttivitaElement) {
            formaAttivitaElement.addEventListener('change', () => {
                updateCassaOptions();
                updateInpsArtComFields();
                updateToggleButtonState();
            });
        }
        if (dipendenteFullTimeElement) {
            dipendenteFullTimeElement.addEventListener('change', () => {
                updateDipendenteFields();
                updateToggleButtonState();
            });
        }
        if (ralDipendenteElement) {
            ralDipendenteElement.addEventListener('blur', () => {
                clampRalDipendente();
                updateToggleButtonState();
            });
            ralDipendenteElement.addEventListener('change', () => {
                clampRalDipendente();
                updateToggleButtonState();
            });
        }
        if (riduzioneContributiDipendenteElement) {
            riduzioneContributiDipendenteElement.addEventListener('change', () => {
                updateRiduzioneFieldsVisibility();
                updateToggleButtonState();
            });
        }
        if (mesiAttivitaElement) {
            mesiAttivitaElement.addEventListener('blur', () => {
                clampMesiAttivita();
                updateToggleButtonState();
            });
            mesiAttivitaElement.addEventListener('change', () => {
                clampMesiAttivita();
                updateToggleButtonState();
            });
        }
        if (riduzione35Element) {
            riduzione35Element.addEventListener('change', updateToggleButtonState);
        }
        if (riduzione50Element) {
            riduzione50Element.addEventListener('change', updateToggleButtonState);
        }
        if (nuovaAttivitaArtComElement) {
            nuovaAttivitaArtComElement.addEventListener('change', () => {
                updateRiduzioneFieldsVisibility();
                updateToggleButtonState();
            });
        }
    }

    function collectParamsObject() {
        const obj = {};
        const setValue = (key, value) => {
            if (value !== undefined && value !== null && value !== '') {
                obj[key] = value;
            }
        };

        setValue('fatturato', fatturatoAnnuoElement?.value || '');
        setValue('anniAttivita', aliquotaIrpefElement?.value || '');
        setValue('tipoAttivita', coefficienteRedditivitàElement?.value || '');
        setValue('formaAttivita', formaAttivitaElement?.value || '');
        setValue('cassa', entePrevidenzialeElement?.value || '');
        setValue('atecoLabel', atecoTrigger?.value || '');
        if (dipendenteFullTimeElement?.checked) {
            setValue('dipendenteFullTime', '1');
            setValue('ralDipendente', ralDipendenteElement?.value || '');
        }
        if (riduzioneContributiDipendenteElement?.checked) {
            setValue('riduzioneDipendente', '1');
        }
        if (isArtComSelected()) {
            setValue('mesiAttivita', mesiAttivitaElement?.value || '');
            setValue('nuovaAttivitaArtCom', nuovaAttivitaArtComElement?.checked ? '1' : '0');
            setValue('riduzione50', riduzione50Element?.checked ? '1' : '0');
            setValue('riduzione35', riduzione35Element?.checked ? '1' : '0');
        }

        return obj;
    }

    function applyParamsToForm(searchParams) {
        let paramsSource = searchParams;
        if (searchParams.has('d')) {
            const decoded = decodeParams(searchParams.get('d'));
            if (decoded) {
                paramsSource = new URLSearchParams();
                Object.entries(decoded).forEach(([key, value]) => paramsSource.set(key, value));
            }
        }
        const setInput = (id, name) => {
            if (!paramsSource.has(name)) return;
            const el = document.getElementById(id);
            if (el) el.value = paramsSource.get(name);
        };

        setInput('ral', 'fatturato');
        setInput('anni-attivita', 'anniAttivita');
        setInput('tipo-attivita', 'tipoAttivita');
        setInput('forma-attivita', 'formaAttivita');
        updateCassaOptions();
        setInput('cassa-previdenziale', 'cassa');
        setInput('mesi-attivita', 'mesiAttivita');
        if (dipendenteFullTimeElement) {
            const fullTimeValue = paramsSource.get('dipendenteFullTime');
            dipendenteFullTimeElement.checked = fullTimeValue === '1' || fullTimeValue === 'true';
        }
        setInput('ral-dipendente', 'ralDipendente');
        if (riduzioneContributiDipendenteElement) {
            const riduzioneValue = paramsSource.get('riduzioneDipendente');
            riduzioneContributiDipendenteElement.checked = riduzioneValue === '1' || riduzioneValue === 'true';
        }
        if (nuovaAttivitaArtComElement) {
            const nuovaAttivitaValue = paramsSource.get('nuovaAttivitaArtCom');
            nuovaAttivitaArtComElement.checked = nuovaAttivitaValue === '1' || nuovaAttivitaValue === 'true';
        }
        if (riduzione50Element) {
            const riduzioneValue = paramsSource.get('riduzione50');
            riduzione50Element.checked = riduzioneValue === '1' || riduzioneValue === 'true';
        }
        if (riduzione35Element) {
            const riduzioneValue = paramsSource.get('riduzione35');
            riduzione35Element.checked = riduzioneValue === '1' || riduzioneValue === 'true';
        }
        if (atecoTrigger) {
            const atecoLabel = paramsSource.get('atecoLabel');
            if (atecoLabel) {
                atecoTrigger.value = atecoLabel;
                atecoTrigger.classList.add('has-value');
                if (atecoSelectedClear) {
                    atecoSelectedClear.hidden = false;
                }
            }
        }

        updateInpsArtComFields();
        updateDipendenteFields();
        updateNuovaAttivitaArtComAvailability();
        clampRalDipendente();
        clampMesiAttivita();
        updateToggleButtonState();
        updateFieldHighlighting();
    }

    function redirectToResultsPage() {
        const paramsObj = collectParamsObject();
        const encoded = encodeParams(paramsObj);
        const queryString = encoded ? `d=${encodeURIComponent(encoded)}` : '';
        const homeUrl = queryString ? `/piva-forfettario?${queryString}` : '/piva-forfettario';
        window.history.replaceState({}, '', homeUrl);
        window.location.href = queryString ? `/piva-forfettario/risultati?${queryString}` : '/piva-forfettario/risultati';
    }

    function redirectToHomeWithQuery() {
        const params = new URLSearchParams(window.location.search);
        const queryString = params.toString();
        const target = queryString ? `/piva-forfettario?${queryString}` : '/piva-forfettario';
        window.location.href = target;
    }

    const searchParams = new URLSearchParams(window.location.search);

    function getParamsObjectFromSearch(params) {
        if (params.has('d')) {
            const decoded = decodeParams(params.get('d'));
            if (decoded && typeof decoded === 'object') {
                return { ...decoded };
            }
        }
        const obj = {};
        params.forEach((value, key) => {
            if (key !== 'd') {
                obj[key] = value;
            }
        });
        return obj;
    }

    function buildEncodedQueryFromObject(paramsObj) {
        const encoded = encodeParams(paramsObj);
        return encoded ? `d=${encodeURIComponent(encoded)}` : '';
    }

    function populateQuickEditCassaOptions(selectedValue = '') {
        if (!pivaQuickEditCassaSelect) return;
        const gestioni = data.gestioni_previdenziali || data.aliquote_contributive || [];
        const baseOption = '<option value="">Seleziona...</option>';
        const options = gestioni
            .map((item) => {
                const value = item.id || item.value || '';
                const label = item.label || item.nome || value;
                if (!value) return '';
                const selected = value === selectedValue ? ' selected' : '';
                return `<option value="${value}"${selected}>${label}</option>`;
            })
            .join('');
        pivaQuickEditCassaSelect.innerHTML = `${baseOption}${options}`;
    }

    function showQuickEditFormattedFatturato() {
        if (!pivaQuickEditFatturatoInput || !pivaQuickEditFatturatoFormattedInput) return;
        let fatturatoValue = parseFloat(pivaQuickEditFatturatoInput.value) || 0;
        if (fatturatoValue < 0) {
            fatturatoValue = 0;
        } else if (fatturatoValue > 1000000) {
            fatturatoValue = 1000000;
        }
        pivaQuickEditFatturatoInput.value = Math.round(fatturatoValue);
        if (fatturatoValue > 0) {
            pivaQuickEditFatturatoFormattedInput.value = `${Math.round(fatturatoValue).toLocaleString('it-IT')} €`;
            pivaQuickEditFatturatoInput.style.display = 'none';
            pivaQuickEditFatturatoFormattedInput.style.display = 'block';
        } else {
            pivaQuickEditFatturatoFormattedInput.value = '';
            pivaQuickEditFatturatoInput.style.display = 'block';
            pivaQuickEditFatturatoFormattedInput.style.display = 'none';
        }
    }

    function showQuickEditNumericFatturato() {
        if (!pivaQuickEditFatturatoInput || !pivaQuickEditFatturatoFormattedInput) return;
        pivaQuickEditFatturatoFormattedInput.style.display = 'none';
        pivaQuickEditFatturatoInput.style.display = 'block';
        pivaQuickEditFatturatoInput.focus();
    }

    function openPivaQuickEditModal() {
        if (!isResultsPage || !pivaQuickEditModal) return;
        const latestParams = new URLSearchParams(window.location.search);
        const paramsData = gatherInputDataFromParams(latestParams);

        if (pivaQuickEditFatturatoInput) {
            pivaQuickEditFatturatoInput.value = Math.round(paramsData.fatturato || 0);
        }
        if (pivaQuickEditAnniAttivitaSelect) {
            pivaQuickEditAnniAttivitaSelect.value = String(paramsData.aliquotaIrpef || '');
        }
        populateQuickEditCassaOptions(paramsData.entePrevidenziale || '');
        showQuickEditFormattedFatturato();

        pivaQuickEditModal.classList.add('is-open');
        pivaQuickEditModal.setAttribute('aria-hidden', 'false');
        pivaQuickEditScrollY = window.scrollY || window.pageYOffset || 0;
        document.documentElement.classList.add('modal-open');
        document.body.classList.add('modal-open');
        document.body.style.position = 'fixed';
        document.body.style.top = `-${pivaQuickEditScrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
    }

    function closePivaQuickEditModal() {
        if (!pivaQuickEditModal) return;
        pivaQuickEditModal.classList.remove('is-open');
        pivaQuickEditModal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('modal-open');
        document.body.classList.remove('modal-open');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, pivaQuickEditScrollY);
        backButtonTop?.focus();
    }

    function gatherInputDataFromForm() {
        return {
            fatturato: parseFloat(fatturatoAnnuoElement?.value) || 0,
            aliquotaIrpef: parseFloat(aliquotaIrpefElement?.value) || 0,
            coefficienteRedditivita: parseFloat(coefficienteRedditivitàElement?.value) || 0,
            formaAttivita: formaAttivitaElement?.value || '',
            entePrevidenziale: entePrevidenzialeElement?.value || '',
            mesiAttivita: parseInt(mesiAttivitaElement?.value, 10) || 12,
            nuovaAttivitaArtCom: nuovaAttivitaArtComElement?.checked || false,
            riduzione50: riduzione50Element?.checked || false,
            riduzione35: riduzione35Element?.checked || false,
            dipendenteFullTime: dipendenteFullTimeElement?.checked || false,
            ralDipendente: parseFloat(ralDipendenteElement?.value) || 0,
            riduzioneDipendente: riduzioneContributiDipendenteElement?.checked || false
        };
    }

    function gatherInputDataFromParams(params) {
        let paramsSource = params;
        if (params.has('d')) {
            const decoded = decodeParams(params.get('d'));
            if (decoded) {
                paramsSource = new URLSearchParams();
                Object.entries(decoded).forEach(([key, value]) => paramsSource.set(key, value));
            }
        }
        return {
            fatturato: parseFloat(paramsSource.get('fatturato')) || 0,
            aliquotaIrpef: parseFloat(paramsSource.get('anniAttivita')) || 0,
            coefficienteRedditivita: parseFloat(paramsSource.get('tipoAttivita')) || 0,
            formaAttivita: paramsSource.get('formaAttivita') || '',
            entePrevidenziale: paramsSource.get('cassa') || '',
            mesiAttivita: parseInt(paramsSource.get('mesiAttivita'), 10) || 12,
            nuovaAttivitaArtCom: paramsSource.get('nuovaAttivitaArtCom') === '1' || paramsSource.get('nuovaAttivitaArtCom') === 'true',
            riduzione50: paramsSource.get('riduzione50') === '1' || paramsSource.get('riduzione50') === 'true',
            riduzione35: paramsSource.get('riduzione35') === '1' || paramsSource.get('riduzione35') === 'true',
            dipendenteFullTime: paramsSource.get('dipendenteFullTime') === '1' || paramsSource.get('dipendenteFullTime') === 'true',
            ralDipendente: parseFloat(paramsSource.get('ralDipendente')) || 0,
            riduzioneDipendente: paramsSource.get('riduzioneDipendente') === '1' || paramsSource.get('riduzioneDipendente') === 'true'
        };
    }

    async function calculateAndRenderResults(inputData) {
        if (!resultSection) return;
        const fatturato = inputData.fatturato || 0;
        const aliquotaIrpef = inputData.aliquotaIrpef || 0;
        const coefficienteRedditività = inputData.coefficienteRedditivita || 0;
        const entePrevidenziale = inputData.entePrevidenziale || '';
        const mesiAttivitaRaw = inputData.mesiAttivita || 12;
        const mesiAttivita = Math.min(Math.max(parseInt(mesiAttivitaRaw, 10) || 12, 1), 12);
        const nuovaAttivitaArtCom = Boolean(inputData.nuovaAttivitaArtCom);
        const riduzione50Richiesta = Boolean(inputData.riduzione50);
        const riduzione35Richiesta = Boolean(inputData.riduzione35);
        const dipendenteFullTime = Boolean(inputData.dipendenteFullTime);
        const ralDipendente = inputData.ralDipendente || 0;
        const riduzioneDipendente = Boolean(inputData.riduzioneDipendente);
        const riduzioneDipendenteAttiva = riduzioneDipendente && dipendenteFullTime && isDipendenteEligible(ralDipendente);

        if (dipendenteFullTime && !isDipendenteEligible(ralDipendente)) {
            redirectToHomeWithQuery();
            return;
        }

        const gestioni = data.gestioni_previdenziali || data.aliquote_contributive || [];
        const contributiva = gestioni.find(item =>
            (item.id || item.value) === entePrevidenziale
        );

        // Calcolo delegato al motore puro condiviso con il confronto tra regimi
        // e con il calcolatore ordinario (stessa logica contributiva).
        const risultato = calcolaForfettario({
            fatturato,
            coefficienteRedditivita: coefficienteRedditività,
            aliquotaImposta: aliquotaIrpef,
            gestione: contributiva,
            mesiAttivita,
            nuovaAttivitaArtCom,
            riduzione50: riduzione50Richiesta,
            riduzione35: riduzione35Richiesta,
            dipendenteFullTime,
            riduzioneDipendente,
            ralDipendente
        });

        imponibileContributi = risultato.imponibileContributi;
        contributi = risultato.contributi;
        imponibileIrpef = risultato.imponibileImposta;
        imposte = risultato.imposta;
        nettoAnnuo = risultato.nettoAnnuo;
        nettoMensile = risultato.nettoMensile;

        document.getElementById('retribuzioneAnnuaNetta').textContent = `${formatEuro(nettoAnnuo)} €`;
        document.getElementById('retribuzioneMensileNetta').textContent = `${formatEuro(nettoMensile)} €`;
        document.getElementById('inpsDipendente').textContent = `${formatEuro(contributi)} €`;
        document.getElementById('irpefNetta2').textContent = `${formatEuro(imposte)} €`;

        const heroAnnuale = document.getElementById('pivaHeroAnnuale');
        if (heroAnnuale) heroAnnuale.textContent = `${formatEuro(nettoAnnuo)} € netti l'anno`;
        const fatturatoTile = document.getElementById('pivaFatturatoTile');
        if (fatturatoTile) fatturatoTile.textContent = `${formatEuro(fatturato)} €`;
        const breakNetto = document.getElementById('pivaBreakNetto');
        if (breakNetto) breakNetto.textContent = `${formatEuro(nettoAnnuo)} €`;
        document.querySelectorAll('.js-fido-tasse').forEach((el) => {
            el.textContent = `${formatEuro(contributi + imposte)} €`;
        });

        // Barra "Dove va il tuo fatturato"
        const pct = (value) => (fatturato > 0 ? Math.max((value / fatturato) * 100, 0) : 0);
        const formatPct = (value) =>
            `${value.toLocaleString('it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
        const setSegment = (segId, pctId, value) => {
            const share = pct(value);
            const seg = document.getElementById(segId);
            if (seg) seg.style.width = `${share}%`;
            const pctEl = document.getElementById(pctId);
            if (pctEl) pctEl.textContent = formatPct(share);
        };
        setSegment('pivaSegNetto', 'pivaPctNetto', nettoAnnuo);
        setSegment('pivaSegContributi', 'pivaPctContributi', contributi);
        setSegment('pivaSegImposte', 'pivaPctImposte', imposte);

        const fatturatoDetail = document.getElementById('fatturatoDetail');
        const coefficienteDetail = document.getElementById('coefficienteDetail');
        const imponibileContributiDetail = document.getElementById('imponibileContributiDetail');
        const imponibileIrpefDetail = document.getElementById('imponibileIrpefDetail');
        const contributiDetail = document.getElementById('contributiDetail');
        const irpefDetail = document.getElementById('irpefDetail');
        const nettoAnnuoDetail = document.getElementById('nettoAnnuoDetail');
        const nettoMensileDetail = document.getElementById('nettoMensileDetail');
        if (fatturatoDetail) fatturatoDetail.value = `${formatEuro(fatturato)} €`;
        if (coefficienteDetail) coefficienteDetail.value = `${formatEuro(coefficienteRedditività)}%`;
        if (imponibileContributiDetail) imponibileContributiDetail.value = `${formatEuro(imponibileContributi)} €`;
        if (imponibileIrpefDetail) imponibileIrpefDetail.value = `${formatEuro(imponibileIrpef)} €`;
        if (contributiDetail) contributiDetail.value = `${formatEuro(contributi)} €`;
        if (irpefDetail) irpefDetail.value = `${formatEuro(imposte)} €`;
        if (nettoAnnuoDetail) nettoAnnuoDetail.value = `${formatEuro(nettoAnnuo)} €`;
        if (nettoMensileDetail) nettoMensileDetail.value = `${formatEuro(nettoMensile)} €`;

        renderConfrontoOrdinario({
            fatturato,
            coefficienteRedditivita: coefficienteRedditività,
            aliquotaImposta: aliquotaIrpef,
            gestione: contributiva,
            formaAttivita: inputData.formaAttivita,
            cassa: entePrevidenziale,
            mesiAttivita,
            nuovaAttivitaArtCom,
            riduzione50: riduzione50Richiesta,
            riduzione35: riduzione35Richiesta,
            dipendenteFullTime,
            riduzioneDipendente,
            ralDipendente
        });

        if (inputSection) inputSection.style.display = 'none';
        resultSection.style.display = 'block';
        window.scrollTo(0, 0);
    }

    // --- Confronto con il regime ordinario ---------------------------------
    // Il forfettario non chiede ne' i costi reali ne' la regione, che servono
    // all'ordinario: i costi partono dalla stima implicita nel coefficiente di
    // redditivita' e la regione e' scegliibile. Il caso piu' importante e'
    // il fatturato oltre gli 85.000 EUR, dove il forfettario non e' piu'
    // un'opzione e l'ordinario e' l'unica strada.
    let confrontoInizializzato = false;
    // Come nell'ordinario: i listener devono leggere l'ultimo contesto, non
    // quello catturato alla prima chiamata (la modifica rapida lo cambia).
    let confrontoCtx = null;
    // I costi partono dalla stima implicita nel coefficiente: finche' l'utente
    // non li tocca vanno riallineati quando cambia il fatturato.
    let costiConfrontoToccati = false;

    function popolaRegioniConfronto(select) {
        if (!select || select.options.length > 0) return;
        const regioni = Object.keys(fiscalData.aliquote_regionali?.['2026'] || {}).sort();
        regioni.forEach((nome) => {
            const opt = document.createElement('option');
            opt.value = nome;
            opt.textContent = nome;
            select.appendChild(opt);
        });
        if (regioni.includes('Lazio')) select.value = 'Lazio';
    }

    function renderConfrontoOrdinario(ctx) {
        if (!document.getElementById('confrontoRegimi')) return;
        confrontoCtx = ctx;
        const costiInput = document.getElementById('confronto-costi');
        const regioneInput = document.getElementById('confronto-regione');

        if (!confrontoInizializzato) {
            popolaRegioniConfronto(regioneInput);
            const ricalcola = () => renderConfrontoOrdinario(confrontoCtx);
            costiInput?.addEventListener('input', () => { costiConfrontoToccati = true; });
            costiInput?.addEventListener('change', ricalcola);
            regioneInput?.addEventListener('change', ricalcola);
            confrontoInizializzato = true;
        }
        if (costiInput && !costiConfrontoToccati) {
            costiInput.value = costiImpliciti(ctx.fatturato, ctx.coefficienteRedditivita);
        }

        const costi = Math.max(0, parseFloat(costiInput?.value) || 0);
        const regione = regioneInput?.value || 'Lazio';

        const esito = confrontaRegimi({
            ricavi: ctx.fatturato,
            costiDeducibili: costi,
            coefficienteRedditivita: ctx.coefficienteRedditivita,
            aliquotaImposta: ctx.aliquotaImposta,
            gestione: ctx.gestione,
            mesiAttivita: ctx.mesiAttivita,
            nuovaAttivitaArtCom: ctx.nuovaAttivitaArtCom,
            riduzione50: ctx.riduzione50,
            riduzione35: ctx.riduzione35,
            dipendenteFullTime: ctx.dipendenteFullTime,
            riduzioneDipendente: ctx.riduzioneDipendente,
            ralDipendente: ctx.ralDipendente,
            regione,
            comune: { aliquota: 0.8 },
            year: '2026'
        }, fiscalData);

        renderConfronto(esito, {
            origine: 'forfettario',
            ctaHref: linkAllOrdinario({
                ricavi: ctx.fatturato,
                costi,
                formaAttivita: ctx.formaAttivita,
                cassa: ctx.cassa,
                regione,
                comune: { aliquota: 0.8 },
                mesiAttivita: ctx.mesiAttivita,
                nuovaAttivitaArtCom: ctx.nuovaAttivitaArtCom,
                riduzione50: ctx.riduzione50,
                dipendenteFullTime: ctx.dipendenteFullTime,
                riduzioneDipendente: ctx.riduzioneDipendente,
                ralDipendente: ctx.ralDipendente
            }),
            notaIpotesi: 'I costi partono dalla stima implicita nel tuo coefficiente di redditività: correggili con quelli veri. ' +
                'L\'addizionale comunale è ipotizzata allo 0,80% (media nazionale): apri il calcolo ordinario per usare quella del tuo comune.'
        });
    }

    // calculation here
    if (toggleButton && !isResultsPage) {
        toggleButton.addEventListener('click', async () => {
            redirectToResultsPage();
        });
    }

    if (backButton) {
        backButton.addEventListener('click', () => redirectToHomeWithQuery());
    }
    if (backButtonTop) {
        if (isResultsPage) {
            backButtonTop.addEventListener('click', () => openPivaQuickEditModal());
        } else {
            backButtonTop.addEventListener('click', () => redirectToHomeWithQuery());
        }
    }

    if (shareButton && isResultsPage) {
        shareButton.addEventListener('click', () => handleShare(shareButton));
    }

    if (faqScrollButton && isResultsPage) {
        faqScrollButton.addEventListener('click', () => {
            const faq = document.querySelector('.faq-container');
            if (faq) {
                faq.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }

    if (detailScrollButton && isResultsPage) {
        detailScrollButton.addEventListener('click', () => {
            const detail = document.getElementById('dettaglio-calcolo');
            if (detail) {
                detail.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }

    pivaQuickEditClose?.addEventListener('click', closePivaQuickEditModal);
    pivaQuickEditModal?.addEventListener('click', (event) => {
        if (event.target === pivaQuickEditModal) closePivaQuickEditModal();
    });
    pivaQuickEditFatturatoInput?.addEventListener('blur', showQuickEditFormattedFatturato);
    pivaQuickEditFatturatoFormattedInput?.addEventListener('focus', showQuickEditNumericFatturato);
    pivaQuickEditFatturatoFormattedInput?.addEventListener('click', showQuickEditNumericFatturato);

    pivaQuickEditForm?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!isResultsPage) return;

        let nextFatturato = parseFloat(pivaQuickEditFatturatoInput?.value) || 0;
        if (nextFatturato < 0) {
            nextFatturato = 0;
        } else if (nextFatturato > 1000000) {
            nextFatturato = 1000000;
        }
        if (pivaQuickEditFatturatoInput) {
            pivaQuickEditFatturatoInput.value = String(Math.round(nextFatturato));
        }
        const nextAnniAttivita = pivaQuickEditAnniAttivitaSelect?.value || '';
        const nextCassa = pivaQuickEditCassaSelect?.value || '';

        if (!nextFatturato || !nextAnniAttivita || !nextCassa) {
            return;
        }

        const latestParams = new URLSearchParams(window.location.search);
        const paramsObj = getParamsObjectFromSearch(latestParams);
        paramsObj.fatturato = String(Math.round(nextFatturato));
        paramsObj.anniAttivita = nextAnniAttivita;
        paramsObj.cassa = nextCassa;
        const cassaToForma = Object.entries(cassaByForma).find(([, values]) => values.includes(nextCassa));
        if (cassaToForma) {
            paramsObj.formaAttivita = cassaToForma[0];
        }

        const queryString = buildEncodedQueryFromObject(paramsObj);
        const targetUrl = queryString ? `/piva-forfettario/risultati?${queryString}` : '/piva-forfettario/risultati';
        window.history.replaceState({}, '', targetUrl);

        const updatedData = gatherInputDataFromParams(new URLSearchParams(queryString));
        await calculateAndRenderResults(updatedData);
        closePivaQuickEditModal();
    });

    pivaQuickEditToConfiguratorButton?.addEventListener('click', () => {
        const queryString = window.location.search;
        const target = queryString ? `/piva-forfettario${queryString}` : '/piva-forfettario';
        window.location.href = target;
    });

    document.addEventListener('keydown', (event) => {
        if (!pivaQuickEditModal || !pivaQuickEditModal.classList.contains('is-open')) return;
        if (event.key === 'Escape') {
            closePivaQuickEditModal();
        }
    });

    if (!isResultsPage && searchParams.size > 0) {
        applyParamsToForm(searchParams);
    }

    if (isResultsPage) {
        const paramsData = gatherInputDataFromParams(searchParams);
        if (!paramsData.fatturato || !paramsData.aliquotaIrpef || !paramsData.coefficienteRedditivita || !paramsData.formaAttivita || !paramsData.entePrevidenziale) {
            redirectToHomeWithQuery();
            return;
        }
        if (resultSection) {
            resultSection.style.display = 'block';
            calculateAndRenderResults(paramsData);
        }
    } else {
        if (inputSection) inputSection.style.display = 'block';
        if (resultSection) resultSection.style.display = 'none';
    }

    if (!isResultsPage && atecoTrigger && atecoModal) {
        let atecoItems = [];
        let atecoLoaded = false;
        let searchTimeout = null;

        const normalizeText = (value) =>
            value
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[^a-z0-9.\s]+/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();

        const formatPercent = (value) => {
            if (!Number.isFinite(value)) return '';
            const rounded = Math.round(value);
            return Math.abs(value - rounded) < 0.01 ? String(rounded) : value.toFixed(2);
        };

        const extractNote = (title, keyword) => {
            if (!title) return null;
            const regex = new RegExp(`\\b${keyword}[a-z]*\\b\\s+(.+)$`, 'i');
            const match = title.match(regex);
            return match ? match[1].trim() : null;
        };

        const buildNotesText = (title) => {
            const inclusion = extractNote(title, 'inclus');
            const exclusion = extractNote(title, 'esclus');
            const notes = [];
            if (inclusion) notes.push(`Inclusioni: ${inclusion}`);
            if (exclusion) notes.push(`Esclusioni: ${exclusion}`);
            return notes.join(' | ');
        };

        const escapeHtml = (value) =>
            value
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/\"/g, '&quot;')
                .replace(/'/g, '&#39;');

        const formatDescriptionHtml = (description) => {
            if (!description) return '';
            const raw = String(description).trim();
            if (!raw) return '';
            const hasDots = raw.includes('•');
            const hasDashes = raw.includes(' - ');
            if (!hasDots && !hasDashes) {
                return `<div class="ateco-result__description">${escapeHtml(raw)}</div>`;
            }

            const firstBulletMatch = raw.match(/•|\s+-\s+/);
            const intro = firstBulletMatch
                ? raw.slice(0, firstBulletMatch.index).trim()
                : '';
            const rest = firstBulletMatch
                ? raw.slice(firstBulletMatch.index).trim()
                : '';
            const introHtml = intro ? `<div class="ateco-result__description">${escapeHtml(intro)}</div>` : '';

            if (hasDashes) {
                const cleanedRest = rest.replace(/^\s*-\s+/, '').trim();
                const rootItems = cleanedRest
                    .split(/\s+-\s+/)
                    .map((part) => part.trim())
                    .filter(Boolean);
                const rootList = rootItems
                    .map((item) => {
                        const parts = item.split('•').map((part) => part.trim()).filter(Boolean);
                        const rootText = parts.shift() || '';
                        const subItems = parts;
                        const subList = subItems.length
                            ? `<ul class="ateco-result__sublist">${subItems
                                  .map((subItem) => `<li>${escapeHtml(subItem)}</li>`)
                                  .join('')}</ul>`
                            : '';
                        return `<li>${escapeHtml(rootText)}${subList}</li>`;
                    })
                    .join('');
                return `${introHtml}<ul class="ateco-result__root-list">${rootList}</ul>`;
            }

            if (hasDots) {
                const dotItems = rest
                    .split('•')
                    .map((part) => part.trim())
                    .filter(Boolean);
                const subList = dotItems.length
                    ? `<ul class="ateco-result__sublist">${dotItems
                          .map((item) => `<li>${escapeHtml(item)}</li>`)
                          .join('')}</ul>`
                    : '';
                return `${introHtml}${subList || `<div class="ateco-result__description">${escapeHtml(raw)}</div>`}`;
            }

            return `<div class="ateco-result__description">${escapeHtml(raw)}</div>`;
        };

        const loadAtecoData = async () => {
            if (atecoLoaded) return;
            // Parcel espone il JSON come namespace del modulo: `default` non c'e' sempre.
            const atecoModule = await import('/data/ateco2025.json');
            const atecoData = atecoModule.default ?? atecoModule;
            const rawItems = Array.isArray(atecoData) ? atecoData : (atecoData.items || []);
            atecoItems = rawItems
                .map((item, index) => {
                    const rawCoeff = Number(item.profitability_coeff);
                    const hasCoeff = Number.isFinite(rawCoeff);
                    const coeffPercent = hasCoeff
                        ? (rawCoeff > 1.5 ? rawCoeff : rawCoeff * 100)
                        : null;
                    return {
                        ...item,
                        _coeffPercent: coeffPercent,
                        _hasCoeff: hasCoeff,
                        _searchKey: normalizeText(item.search_key || ''),
                        _titleNorm: normalizeText(item.title_norm || ''),
                        _codeNorm: normalizeText(item.code || ''),
                        _codeNoDots: normalizeText(item.code_nodots || ''),
                        _index: index
                    };
                })
                .filter((item) => item._hasCoeff);
            ;
            atecoLoaded = true;
        };

        const renderEmptyState = (message) => {
            atecoSearchResults.innerHTML = '';
            atecoSearchEmpty.textContent = message;
            atecoSearchEmpty.style.display = 'block';
        };

        const renderResults = (results) => {
            if (!results.length) {
                renderEmptyState('Nessun risultato trovato.');
                return;
            }
            atecoSearchEmpty.style.display = 'none';
            atecoSearchResults.innerHTML = results
                .map((item) => {
                    const coeff = formatPercent(item._coeffPercent);
                    const notes = buildNotesText(item.title_it);
                    const notesHtml = notes ? `<div class="ateco-result__note">${notes}</div>` : '';
                    const descriptionHtml = formatDescriptionHtml(item.description_it || '');
                    return `
                        <button type="button" class="ateco-result" data-index="${item._index}">
                          <div class="ateco-result__title">${item.code} - ${item.title_it}</div>
                          <div class="ateco-result__meta">Coeff. redditività ${coeff}%</div>
                          ${descriptionHtml}
                          ${notesHtml}
                        </button>
                    `;
                })
                .join('');
        };

        const searchAteco = (query) => {
            const normalizedQuery = normalizeText(query);
            const rawQuery = query.trim().toLowerCase();
            const rawCompact = rawQuery.replace(/\./g, '');
            if (!normalizedQuery) {
                renderEmptyState('Inizia a digitare per vedere i risultati.');
                return;
            }
            const tokens = normalizedQuery.split(' ');
            const compactQuery = normalizedQuery.replace(/\./g, '');
            const scored = [];
            atecoItems.forEach((item) => {
                const haystack = `${item._searchKey} ${item._titleNorm} ${item._codeNoDots}`;
                const rawHaystack = `${item.search_key || ''} ${item.title_it || ''} ${item.code_nodots || ''} ${item.code || ''}`.toLowerCase();
                const rawCompactHaystack = rawHaystack.replace(/\./g, '');
                const rawMatch = rawQuery && rawHaystack.includes(rawQuery);
                const rawCompactMatch = rawCompact && rawCompactHaystack.includes(rawCompact);
                const normalizedMatch = tokens.every((token) => haystack.includes(token));
                if (!rawMatch && !rawCompactMatch && !normalizedMatch) return;
                let score = 0;
                if (item._codeNorm === normalizedQuery) score += 6;
                if (item._codeNorm.startsWith(normalizedQuery)) score += 4;
                if (item._codeNoDots && item._codeNoDots.startsWith(compactQuery)) score += 3;
                if (item._titleNorm.includes(normalizedQuery)) score += 2;
                score += item.search_boost || 0;
                scored.push({ item, score });
            });
            scored.sort((a, b) => {
                if (b.score !== a.score) return b.score - a.score;
                return (a.item.code_len || 0) - (b.item.code_len || 0);
            });
            renderResults(scored.slice(0, 20).map((entry) => entry.item));
        };

        const extractAtecoCode = (value) => {
            if (!value) return '';
            const match = value.trim().match(/^([0-9.]+)/);
            return match ? match[1] : '';
        };

        const openModal = async () => {
            atecoModal.classList.add('is-open');
            atecoModal.setAttribute('aria-hidden', 'false');
            document.body.classList.add('modal-open');
            const prefillQuery = extractAtecoCode(atecoTrigger?.value || '');
            atecoSearchInput.value = prefillQuery;
            renderEmptyState('Caricamento in corso...');
            try {
                await loadAtecoData();
                if (atecoItems.length === 0) {
                    renderEmptyState('Nessun record ATECO disponibile.');
                    return;
                }
                if (prefillQuery) {
                    searchAteco(prefillQuery);
                } else {
                    renderEmptyState('Inizia a digitare per vedere i risultati.');
                }
                setTimeout(() => atecoSearchInput.focus(), 50);
            } catch (error) {
                console.warn('Elenco ATECO non caricato', error);
                renderEmptyState('Errore nel caricamento dei dati. Riprova tra poco.');
            }
        };

        const closeModal = () => {
            atecoModal.classList.remove('is-open');
            atecoModal.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('modal-open');
        };

        const setSelection = (item) => {
            const coeffValue = formatPercent(item._coeffPercent);
            coefficienteRedditivitàElement.value = coeffValue;
            const notes = buildNotesText(item.title_it);
            atecoTrigger.value = `${item.code} - ${item.title_it} • ${coeffValue}%`;
            atecoTrigger.title = notes ? `${item.code} - ${item.title_it} | ${notes}` : `${item.code} - ${item.title_it}`;
            atecoTrigger.classList.add('has-value');
            atecoSelectedClear.hidden = false;
            updateToggleButtonState();
            updateFieldHighlighting();
        };

        const clearSelection = () => {
            coefficienteRedditivitàElement.value = '';
            atecoTrigger.value = '';
            atecoTrigger.removeAttribute('title');
            atecoTrigger.classList.remove('has-value');
            atecoSelectedClear.hidden = true;
            updateToggleButtonState();
            updateFieldHighlighting();
        };

        atecoTrigger.addEventListener('click', openModal);
        atecoSelectedClear.addEventListener('click', clearSelection);

        atecoModal.addEventListener('click', (event) => {
            if (event.target.matches('[data-ateco-close]')) {
                closeModal();
            }
        });

        atecoModal.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closeModal();
            }
        });

        atecoSearchInput.addEventListener('input', (event) => {
            if (searchTimeout) window.clearTimeout(searchTimeout);
            searchTimeout = window.setTimeout(() => {
                const query = event.target.value;
                const runSearch = () => searchAteco(query);
                if (atecoLoaded) {
                    runSearch();
                    return;
                }
                renderEmptyState('Caricamento in corso...');
                loadAtecoData()
                    .then(() => {
                        if (atecoItems.length === 0) {
                            renderEmptyState('Nessun record ATECO disponibile.');
                            return;
                        }
                        runSearch();
                    })
                    .catch(() => renderEmptyState('Errore nel caricamento dei dati. Riprova tra poco.'));
            }, 120);
        });

        atecoSearchResults.addEventListener('click', (event) => {
            const target = event.target.closest('.ateco-result');
            if (!target) return;
            const index = parseInt(target.dataset.index, 10);
            const item = atecoItems[index];
            if (!item) return;
            setSelection(item);
            closeModal();
        });

        if (coefficienteRedditivitàElement.value) {
            if (!atecoTrigger.value) {
                atecoTrigger.value = `Coeff. redditività ${coefficienteRedditivitàElement.value}%`;
            }
            atecoTrigger.classList.add('has-value');
            atecoSelectedClear.hidden = false;
        }
    }




    

})
